import * as testConst from 'app/constants/tests';
import Image from 'app/components/layouts/Image';
import { useAudioManager } from './AudioManager';
import { useRef } from 'react';
import env from '.env.json';

interface ImageAudioProps {
  data: any;
  hide: boolean;
  width?: number;
}

const ImageAudio = (props: ImageAudioProps) => {
  if (!props.data) return <></>;
  const data = props.data;
  const READ_PART = [testConst.TOEIC_P5, testConst.TOEIC_P6, testConst.TOEIC_P7];
  const showRadio = !data?.part_id || !READ_PART.includes(data.part_id);
  const audioRef = useRef<HTMLAudioElement>(null);
  const { registerAndPlay } = useAudioManager();

  const handlePlay = () => {
    if (audioRef.current) {
      registerAndPlay(audioRef.current);
    }
  };

  return (
    <div className="group-image-audio">
      {data.description && !props.hide &&
        <div className='form-group'>
          <div className='des-box'>
            <div dangerouslySetInnerHTML={{ __html: data.description }} />
          </div>
        </div>
      }
      {data.audio && showRadio &&
        <div className='form-group audio-box'>
          <audio
            controlsList="nodownload"
            src={`${env.URL_APP_FILE || env.URL_API}/storage/${data.audio}`}
            ref={audioRef}
            onPlay={handlePlay}
            controls
          />
        </div>
      }
      {data.image && !props.hide &&
        <div className='form-group image-box'>
          <Image
            alt="image"
            width={props.width || 750}
            height={props.width || 750}
            style={{ width: '100%', height: 'auto', maxWidth: props.width || 750 }}
            src={`${env.URL_APP_FILE || env.URL_API}/storage/${data.image}`}
          />
        </div>
      }
    </div>
  )
}

export default ImageAudio;
